import { Button, Header, Icon, Modal, Segment } from '@mairistem/composants';

type ModalChoixTypeRegieProps = {
  onSelect: (autonome: boolean) => void;
  onCancel: () => void;
  canCancel?: boolean;
};

const ModalChoixTypeRegie = ({
  onSelect,
  onCancel,
  canCancel = true,
}: ModalChoixTypeRegieProps) => (
  <Modal
    open
    size="small"
    {...(canCancel && {
      onClose: onCancel,
      closeIcon: true,
    })}
  >
    <Modal.Header>Création d&apos;une régie</Modal.Header>
    <Modal.Content>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          columnGap: '1em',
        }}
      >
        <Button
          as={Segment}
          color="blue"
          basic
          style={{
            flex: 1,
            margin: 0,
            padding: '1.5em',
            textAlign: 'center',
            cursor: 'pointer',
          }}
          onClick={() => onSelect(false)}
        >
          <div style={{ margin: '0 0 0.5em 0' }}>
            <Icon iconSet="Lucide" name="FileInput" size={30} />
          </div>
          <Header as="h4" style={{ margin: 0 }}>
            <Header.Content>Régie encaissant sur facture</Header.Content>
          </Header>
        </Button>

        <Button
          as={Segment}
          color="blue"
          basic
          style={{
            flex: 1,
            margin: 0,
            padding: '1.5em',
            textAlign: 'center',
            cursor: 'pointer',
          }}
          onClick={() => onSelect(true)}
        >
          <div style={{ margin: '0 0 0.5em 0' }}>
            <Icon iconSet="Lucide" name="ReceiptEuro" size={30} />
          </div>
          <Header as="h4" style={{ margin: 0 }}>
            <Header.Content>Régie encaissant au comptant</Header.Content>
          </Header>
        </Button>
      </div>
    </Modal.Content>
    <Modal.Actions>
      <Button
        onClick={onCancel}
        basic
        size="tiny"
        icon={canCancel ? 'close' : 'home'}
        content={canCancel ? 'Annuler la création' : "Retourner à l'accueil"}
      />
    </Modal.Actions>
  </Modal>
);

export default ModalChoixTypeRegie;
